var _excluded = ["innerProps"],
    _excluded2 = ["id", "value", "onChange", "loadOptions", "defaultValue", "emptyState"];

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useRef, useState } from 'react';
import { components } from 'react-select';
import ReactAsyncSelect from 'react-select/async';
import { forwardRef, useDebounceCallback } from '../../../utils';
import { customStyles, flatOptionsArrayRec, menuProps, selectComponents } from './_Select';
import { SelectMessage } from './components/SelectMessage/SelectMessage';
import { jsx as _jsx } from "react/jsx-runtime";

var asyncSelectComponents = _objectSpread({}, selectComponents);

asyncSelectComponents.SelectContainer = _ref => {
  var {
    innerProps
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(components.SelectContainer, _objectSpread(_objectSpread({}, props), {}, {
    innerProps: _objectSpread(_objectSpread({}, innerProps), {}, {
      'data-component': '_AsyncSelect'
    })
  }));
};

/**
 * @private Please use `Form.AsyncSelect` from `@melio/penny`.
 */
export var _AsyncSelect = forwardRef((_ref2, ref) => {
  var {
    id,
    value,
    onChange,
    loadOptions,
    defaultValue,
    emptyState
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var [hasLoadedOptions, setHasLoadedOptions] = useState(false);
  var [options, setOptions] = useState([]);
  var isMounted = useRef(true);
  useEffect(() => () => {
    isMounted.current = false;
  }, []);
  var loadSuggestedOptions = useDebounceCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (inputValue, callback) {
      var options = yield loadOptions(inputValue);

      if (!isMounted.current) {
        return;
      }

      var flatOptions = flatOptionsArrayRec(options, [], 0);
      setOptions(flatOptions);
      setHasLoadedOptions(true);
      callback(flatOptions);
    });

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), 500); // The selected value must be an option from the options list, yet we want to work with the value itself.
  // Match the react-select's onChange to a native "event"-like onChange.

  var handleChange = selectedOption => onChange === null || onChange === void 0 ? void 0 : onChange({
    target: {
      value: selectedOption.value
    }
  });

  return /*#__PURE__*/_jsx(ReactAsyncSelect // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
  , _objectSpread(_objectSpread({
    ref: ref,
    components: asyncSelectComponents,
    menuPortalTarget: document.body,
    styles: customStyles(),
    openMenuOnFocus: false,
    openMenuOnClick: false
  }, props), {}, {
    onChange: newValue => handleChange(newValue),
    value: hasLoadedOptions ? options.find(option => option.value === value) : defaultValue,
    loadOptions: loadSuggestedOptions,
    inputId: id,
    loadingMessage: () => /*#__PURE__*/_jsx(SelectMessage, {
      label: "Loading..."
    }),
    noOptionsMessage: () => /*#__PURE__*/_jsx(SelectMessage, _objectSpread(_objectSpread({}, emptyState), {}, {
      label: (emptyState === null || emptyState === void 0 ? void 0 : emptyState.label) || 'No options'
    }))
  }, menuProps));
});
_AsyncSelect.displayName = '_AsyncSelect';
//# sourceMappingURL=_AsyncSelect.js.map